"use strict";
import crypto from 'crypto' // 加密
import axios from "axios";

// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const baseURL = process.env.baseURL || process.env.apiUrl || "https://d.apicloud.com/mcm/api";
const timeout = 3000;
const withCredentials = false; // Check cross-site Access-Control
const app_id= '';//'A6045900985876';
const app_key= '';//'561084B2-4AFB-9279-7F7F-0B555DF7658B'

const now = Date.now(); //当前时间
const sha1 = crypto.createHash('sha1');

sha1.update(app_id + "UZ" + app_key + "UZ" + now);
// 添加请求头  
axios.defaults.headers["X-APICloud-AppId"] = app_id;
axios.defaults.headers["X-APICloud-AppKey"] = sha1.digest('hex') + "." + now;


const _axios = axios.create({
    baseURL,timeout,withCredentials
});

// _axios.interceptors.request.use(
//     function(config) {
//         return config;
//     },
//     function(error) {
//         // Do something with request error
//         return Promise.reject(error);
//     }
// );

// // Add a response interceptor
// _axios.interceptors.response.use(
//     function(response) {
//         // Do something with response data
//         return response;
//     },
//     function(error) {
//         // Do something with response error
//         return Promise.reject(error);
//     }
// );


const get = async (api)=> await _axios({url:api, type:'get'});
const post = async (api,data)=> await _axios.post(api,data);
const auth = async (token) => _axios.defaults.headers['Authorization'] =token;

const request  = {
    get,post,auth
}

export default request;








